import { parse } from "date-fns/parse";
import { handleDateRangeCalendarChange, handleSingleDateCalendarChange, isString } from "../shared/utils/form-date.js";
function formUtils_handleDateRangeCalendarChange(setValue, watchStartLabel, watchEndLabel, setDefaultMonth, dates) {
    handleDateRangeCalendarChange(setValue, watchStartLabel, watchEndLabel, setDefaultMonth, dates, {
        clearEndDateOnStart: true
    });
}
function getPartStaySelectedDates(watchHotelStartDate, watchHotelEndDate, watchStartDate, watchEndDate) {
    if (watchHotelStartDate) return {
        from: parse(watchHotelStartDate, 'yyyyMMdd', new Date()),
        to: watchHotelEndDate ? parse(watchHotelEndDate, 'yyyyMMdd', new Date()) : void 0
    };
    return {
        from: watchStartDate ? parse(watchStartDate, 'yyyyMMdd', new Date()) : void 0,
        to: watchEndDate ? parse(watchEndDate, 'yyyyMMdd', new Date()) : void 0
    };
}
export { getPartStaySelectedDates, formUtils_handleDateRangeCalendarChange as handleDateRangeCalendarChange, handleSingleDateCalendarChange, isString };
